"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _SttContainer = _interopRequireDefault(require("../SttLayout/SttContainer"));
var _SttPaper = _interopRequireDefault(require("../SttSurfaces/SttPaper"));
var _SttText = _interopRequireDefault(require("../SttTypography/SttText"));
var _SttLink = _interopRequireDefault(require("../SttTypography/SttLink"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    card: {
      padding: theme.spacing(1, 2, 1, 2),
      marginTop: theme.spacing(0.5),
      marginBottom: theme.spacing(0.5),
      borderRadius: theme.spacing(1),
      position: 'relative',
      textAlign: 'center',
      minWidth: function minWidth(props) {
        return props.minWidth || '70%';
      },
      maxWidth: '70%',
      boxShadow: '0 1px 2px #00000029',
      '&::before': {
        content: "'' ''",
        height: 0,
        position: 'absolute',
        top: '22px',
        width: 0,
        zIndex: 1,
        right: '30px;',
        border: 'medium solid black',
        borderWidth: '10px 0 10px 10px',
        borderColor: 'transparent black transparent transparent'
      }
    },
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    },
    time: {
      fontSize: '0.8em',
      color: theme.palette.texto_chat.primary
    },
    name: {
      fontWeight: 600,
      color: theme.palette.indicacao_fala_usuario.primary
    },
    message: {
      color: theme.palette.texto_chat.primary
    }
  };
});
function SttMensagemAviso(props) {
  var mensagem = props.mensagem,
    atendimento = props.atendimento,
    _props$callbackAcao = props.callbackAcao,
    callbackAcao = _props$callbackAcao === void 0 ? null : _props$callbackAcao;
  var classes = useStyles(props);
  var cor = atendimento ? '#e1f5feeb' : '#fff5c4';
  return /*#__PURE__*/_react["default"].createElement(_SttContainer["default"], {
    className: classes.container
  }, /*#__PURE__*/_react["default"].createElement(_SttPaper["default"], {
    className: classes.card,
    style: {
      backgroundColor: cor
    }
  }, /*#__PURE__*/_react["default"].createElement(_SttText["default"], {
    size: "small"
  }, mensagem), callbackAcao && /*#__PURE__*/_react["default"].createElement(_SttLink["default"], {
    target: "_blank",
    style: {
      cursor: 'pointer'
    },
    variant: "body2",
    onClick: function onClick(e) {
      e.preventDefault();
      callbackAcao();
    }
  }, "Clique aqui!")));
}
var _default = SttMensagemAviso;
exports["default"] = _default;